import './SidebarEventMenu.scss';
import EventIcon from "@mui/icons-material/Event";
import BookIcon from "@mui/icons-material/Book";
import participants_icon from "../../../assets/images/participants-icon.svg";
import participants_blue_icon from "../../../assets/images/participants-blue-icon.svg";
import { ReactComponent as TaskIcon } from "../../../assets/images/tasks.svg";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { isMobileApp } from "../../../helpers/helpers";

export const SidebarEventMenu = ({ sidebarRouteData, currentCourse, className, iconSize }: any) => {
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname;
  const { id } = sidebarRouteData;
  const [t] = useTranslation("common");

  const { totalEventTasks, userCompletedEventTasks, isTotalEventTasksLoading } = useSelector((state: any) => state.content);

  //check if the participants is active for change the img src
  const isParticipantsActive = () => {
    return path.includes("/participants");
  };

  const isActive = (btnName: string) => {
    let result = "item py-md-4 px-md-3 py-3 px-1 d-flex align-items-center";
    if (path)
      switch (btnName) {
        case "timeline":
          const tactive = path.indexOf("/timeline/");
          if (tactive > -1) result += " active";
          break;
        case "library":
          const lactive = path.indexOf("/library/");
          if (lactive > -1) result += " active";
          break;
        case "participants":
          if (isParticipantsActive()) result += " active";
          break;
        case "tasks":
          const active = path.indexOf("/tasks/");
          if (active > -1) result += " active";
          break;
      }
    return result;
  };

  const goTo = (path: string) => {
    if (path !== "") {
      if (id) {
        navigate(path + id);
      }
    } else {
      if (currentCourse) {
        const isMobile = isMobileApp();
        const target = isMobile ? "_self" : "_blank";
        window.open("https://www.google.com", target);
      }
    }
  };

  return (
    <div className={`${className}`}>
      <div className="menu-items">
        <div className={isActive("timeline")} onClick={() => goTo("/my-campus/event/timeline/")}>
          <EventIcon sx={{ fontSize: iconSize }} />
          <span className="mx-2">{navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/iPhone/i) ? t("Agenda") : t("Seminar Agenda")}</span>
        </div>
        <div className={isActive("library")} onClick={() => goTo("/my-campus/event/library/")}>
          <BookIcon sx={{ fontSize: iconSize }} />
          <span className="mx-2">{navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/iPhone/i) ? t("Library") : t("Seminar Library")}</span>
        </div>
        {(navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/iPhone/i)) && (
          <div className={isActive("participants")} onClick={() => goTo("/my-campus/event/participants/")}>
            <img src={isParticipantsActive() ? participants_blue_icon : participants_icon} alt="" style={{ width: "20px", height: "20px" }} />
            <span className="mx-2">{t("Participants")}</span>
          </div>
        )}
        {totalEventTasks > 0 && (
          <div className={isActive("tasks")} onClick={() => goTo("/my-campus/event/tasks/")}>
            <TaskIcon size={iconSize} />
            <span className="mx-2">
              {t("Tasks")}
              {!isTotalEventTasksLoading && (<span className={`sideBarTasksBaloon ${isActive ? "sideBarTasksBaloonNonActive" : null}`}>
                {userCompletedEventTasks}/{totalEventTasks}
              </span>)}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};